import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { CurrencyFormat } from '@lt/components';
import type { CurrencyType } from '@lt/components/utils/currency';
import { pluralize } from '@lt/components/utils/userflow';
import BubbleFilter from 'src/components/Bubbles/BubbleFilter';
import styles from './filterLabel.module.css';

interface IFilterLable {
  className?: string;
  price?: string | number;
  currencyCode?: CurrencyType;
  name: string;
  description?: string;
  count?: number;
  disabled?: boolean;
  selected?: boolean;
  isMobile?: boolean;
  emptyMessage?: string;
}

const FilterLabel: React.FC<IFilterLable> = ({
  count = 0,
  price,
  currencyCode,
  name,
  emptyMessage = 'нет отелей',
  description,
  isMobile = false,
  selected = false,
  disabled = false,
  className,
}) => {
  const hasOffersCount = count > 0;
  return (
    <div
      className={classnames(className, styles.filterLabel, {
        [styles.filterLabelMobile]: isMobile,
        [styles.filterLabelNotDisabled]: !disabled,
        [styles.filterLabelNotDisabledAndSelected]: !disabled && selected,
        [styles.filterLabelDisabled]: disabled,
        [styles.filterLabelDisabledOrSelected]: selected || disabled,
      })}
    >
      <div
        className={classnames(styles.itemNameContainer, {
          [styles.itemNameContainerDesktop]: !isMobile,
        })}
      >
        {name}
        {description && !isMobile ? (
          <BubbleFilter text={description} placement="right" />
        ) : null}
      </div>
      <div className={styles.itemInfo}>
        {!disabled && hasOffersCount && (
          <>
            {`${count} ${pluralize(count, ['отель', 'отеля', 'отелей'])}`}
            <CurrencyFormat
              value={price}
              currencyCode={currencyCode}
              prefix=" от "
            />
          </>
        )}
        {disabled ? emptyMessage : null}
      </div>
    </div>
  );
};

FilterLabel.propTypes = {
  className: PropTypes.string,
};

FilterLabel.defaultProps = {
  className: '',
};

export default React.memo(FilterLabel);
